<template>
  <div>
    <table
      v-if="loading == false"
      class="uk-table metatrader-accounts-table uk-table-hover uk-table-divider"
    >
      <thead>
        <tr>
          <th>LOGIN</th>
          <th>SYMBOL</th>
          <th>ACTION</th>
          <th>VOLUME</th>
          <th>CLOSE TIME</th>
          <th>OPEN PRICE</th>
          <th>CLOSE PRICE</th>
          <th>PROFIT</th>
        </tr>
      </thead>
      <tbody v-if="results">
        <tr :key="result.Deal" v-for="result in results">
          <td>
            <b>{{ result.Login }}</b>
          </td>
          <td>
            <b>{{ result.Symbol }}</b>
          </td>
          <td>{{ actionKey[result.Action] }}</td>
          <td>{{ result.VolumeClosed / 1000 }}</td>

          <td>
            {{ result.Time | formatDate }}
          </td>
          <td>{{ result.PriceOpen }}</td>
          <td>{{ result.PriceCurrent }}</td>
          <td>{{ result.Profit }}</td>
        </tr>
      </tbody>
    </table>

    <div class="center flex items-center justify-center" v-else>
      <vk-spinner></vk-spinner>
    </div>
  </div>
</template>

<script>
import EventBus from "../../../../components/Ui/EventBus";
import http from "../../../../services/http";
export default {
  props: ["login", "type"],
  data() {
    return {
      loading: true,
      results: [],
      actionKey: ["Alış", "Satış"],
    };
  },
  methods: {
    getData() {
      http.mt5
        .getUserClosedPositions({ login: this.login, type: this.type })
        .then((e) => {
          this.results = e.data.result;
          this.loading = false;
        });
    },
  },
  mounted() {
    EventBus.$on("Services.orders", (login) => {
      this.getData(login);
    });
    this.getData();
  },
};
</script>

<style></style>
